<template>
  <DataList
    title="Виконавці"
    resource="employees"
    :columns="columns"
    :disable-adding="true"
    :get-items-fn="getEmployees"
    :search-label="'Пошук за ПІБ'"
  />
</template>

<script>
import * as employeesApi from "../../../backend/employeesApi.js";

export default {
  data: () => ({
    columns: [
      { title: "id", name: "id", dataPath: "id" },
      { title: "ПІБ", name: "title" },
      { title: "Департамент", name: "department" },
    ],
  }),
  methods: {
    getEmployees(...args) {
      return employeesApi.getEmployees(args[0], args[1], args[2], args[3]);
    },
  },
};
</script>
